import {forwardRef, HTMLAttributes} from 'react'
import {StyledOverlay} from '@components/ui/overlay/style.ts'

export const Overlay = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement> & {$type?: 'light' | 'dark'}>(
    (props, ref) => <StyledOverlay ref={ref} {...props} />
)
